// extracted by mini-css-extract-plugin
module.exports = {"layout":"AppLayout--layout--2MnEp"};